export default __webpack_public_path__ + "static/media/superball_mob_light.1f29382e.png";